export default __webpack_public_path__ + "static/assets/604d7a3cd1ab1329a8a57468d1631c4d.png";